import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

type RelayMessengerNavLinkProps = Omit<NavLinkProps, 'style'> & {
  style?: NavLinkProps['style'];
  activeFontWeight?: React.CSSProperties['fontWeight'];
  inactiveFontWeight?: React.CSSProperties['fontWeight'];
  color?: React.CSSProperties['color'];
};

export const RelayMessengerNavLink = ({
  activeFontWeight,
  inactiveFontWeight,
  color = '#212529',
  style,
  ...props
}: RelayMessengerNavLinkProps) => {
  return (
    <NavLink
      {...props}
      style={(state) => {
        const resolvedFontWeight = state.isActive
          ? activeFontWeight
          : inactiveFontWeight;
        const callerStyle = typeof style === 'function' ? style(state) : style;

        return {
          color,
          textDecoration: 'none',
          ...(resolvedFontWeight !== undefined
            ? { fontWeight: resolvedFontWeight }
            : {}),
          ...callerStyle,
        };
      }}
    />
  );
};
